import { put, select, fork, take, race } from "redux-saga/effects";
import { dispatchGeneratorFunc } from "../helpers/helpers";
import {
  setShouldRequestInsights,
  setShouldRequestMonitoring,
} from "./requestSchedule";

const INITIAL_STATE = {
  pending: true,
  complete: false,
  error: undefined,
};

export const UNSNOOZE_RULE_EQUIP = "bonfire/_BETA/triage/UNSNOOZE_RULE_EQUIP";
export const UNSNOOZE_RULE_EQUIP_REQUEST =
  "bonfire/_BETA/triage/UNSNOOZE_RULE_EQUIP_REQUEST";
export const UNSNOOZE_RULE_EQUIP_REQUEST_SUCCESS =
  "bonfire/_BETA/triage/UNSNOOZE_RULE_EQUIP_REQUEST_SUCCESS";
export const UNSNOOZE_RULE_EQUIP_REQUEST_FAIL =
  "bonfire/_BETA/triage/UNSNOOZE_RULE_EQUIP_REQUEST_FAIL";

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case UNSNOOZE_RULE_EQUIP_REQUEST:
      return {
        ...state,
        pending: true,
        complete: false,
        error: undefined,
      };
    case UNSNOOZE_RULE_EQUIP_REQUEST_SUCCESS:
      return {
        ...state,
        pending: false,
        complete: true,
        error: undefined,
      };
    case UNSNOOZE_RULE_EQUIP_REQUEST_FAIL:
      return {
        ...state,
        pending: false,
        complete: true,
        error: action.error,
      };
    default: {
      return state;
    }
  }
}

export const unsnoozeEquipRules = ({ equipRuleIds }) => ({
  type: UNSNOOZE_RULE_EQUIP,
  equipRuleIds,
});

export const deleteSnoozeEquipRule = ({ equipRuleIds, token }) => ({
  types: [
    UNSNOOZE_RULE_EQUIP_REQUEST,
    UNSNOOZE_RULE_EQUIP_REQUEST_SUCCESS,
    UNSNOOZE_RULE_EQUIP_REQUEST_FAIL,
  ],
  promise: (client) =>
    client.delete("/synco/equipRule/snooze", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { equipRuleIds },
    }),
});

const getAuthUser = (state) => state.auth.user;
export function* unsnoozeEquipRuleFlow() {
  while (true) {
    const { equipRuleIds } = yield take(UNSNOOZE_RULE_EQUIP);

    try {
      const user = yield select(getAuthUser);

      // Check that user has necessary permissions to make request
      if (!user.rolesRestriction) throw Error("Unable to authenticate user");

      // validate that at least one equipRuleId has been given
      if (!equipRuleIds) throw Error("No equipRuleIds given");

      yield fork(dispatchGeneratorFunc, deleteSnoozeEquipRule, {
        token: user.token,
        equipRuleIds,
      });

      const { success, failure } = yield race({
        success: take(UNSNOOZE_RULE_EQUIP_REQUEST_SUCCESS),
        failure: take(UNSNOOZE_RULE_EQUIP_REQUEST_FAIL),
      });

      if (failure) {
        throw new Error("Failed to snooze ruleEquips");
      }
      if (success) {
        yield put(setShouldRequestInsights(true));
        yield put(setShouldRequestMonitoring(true));
      }
    } catch (err) {
      console.error(
        `Something went wrong attempting to wake up rule equip: ${err}`
      );
    }
  }
}
